module.exports = "<div id=\"map\"></div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/maps/maps.component.html
// module id = ../../../../../src/app/maps/maps.component.html
// module chunks = main